import i18n from "@/i18n";
import PageForm from "@/assets/ts/interfaces/form/pageForm";
import { Types } from "@/assets/ts/enums/form/types";

function getGoals() {
  const goals: PageForm =
  {
    title: i18n.global.t('proposal.form.side_panel.title'),
    image: require('@/assets/img/windmill.png'),
    name: i18n.global.t('proposal.form.side_panel.goals'),
    form: [
      {
        title: '',
        titleMobile: i18n.global.t('proposal.form.goals.title_mobile'),
        fields: [
          {
            key: "purpose",
            value: "",
            title: i18n.global.t('proposal.form.goals.title'),
            options: i18n.global.tm("proposal.form.goals.options"),
            rules: "required",
            separatedRadio: true,
            type: Types.RADIO
          },
          {
            key: "purpose_description",
            title: i18n.global.t("proposal.form.goals.textarea.title"),
            value: "",
            conditionalOn: "purpose",
            rules: "required|minLength:20|maxLength:180",
            placeholder: i18n.global.t("proposal.form.goals.textarea.placeholder"),
            type: Types.TEXTAREA
          }
        ],
        next: true,
        back: true,
        backLink: '/proposal'
      },

    ],
    sub_steps: []
  }
  return goals
}


export default getGoals
